module.exports = __webpack_public_path__ + "img/global.d52100a7.png";